import { useCallback, useMemo, useState } from 'react';

type UseChunksParams<T> = {
  items: T[] | undefined;
  perChunk: number;
};

export function useChunked<T>({ items, perChunk }: UseChunksParams<T>) {
  const [currentChunk, setCurrentChunk] = useState(1);

  const dataChunk = useMemo(() => {
    const itemsChunk = items?.slice(0, currentChunk * perChunk) || [];
    const numberItems = items?.length || 0;
    const numberItemsInChunk = itemsChunk.length;

    return { itemsChunk, numberItems, numberItemsInChunk };
  }, [items, currentChunk, perChunk]);

  const nextChunk = useCallback(() => {
    setCurrentChunk((s) => s + 1);
  }, [setCurrentChunk]);

  return { ...dataChunk, nextChunk };
}
